import classNames from 'classnames'
import { isSameDay } from 'date-fns'

import { NUMBER_SIZE } from '../../../constants/size'
import { Day } from '../Day'

import { formatMonthDay } from './MonthDay.utils'

import * as styles from './MonthDay.module.css'

/**
 * @typedef {Object} MonthDayComponentProps
 * @property {string} className
 * @property {NumberSize} size
 */

/**
 * @typedef {TProps} MonthDayProps
 * @template {MonthDayComponentProps} TProps
 *
 * @property {React.ComponentType<TProps>} Component
 * @property {string} [className]
 * @property {boolean} [current]
 * @property {Object} [currentClassName]
 * @property {(value: Date) => string} [format]
 * @property {NumberSize} size
 * @property {Date} [today]
 * @property {string} [todayClassName]
 * @property {Date} value
 */

/**
 * @param {MonthDayProps<DayProps>} props
 */
function MonthDay({
  Component = Day,
  className = styles.MonthDay,
  current,
  currentClassName = styles.current,
  format = formatMonthDay,
  size = NUMBER_SIZE.size40,
  today,
  todayClassName = styles.today,
  value,
  ...componentProps
}) {
  const componentClassName = classNames(className, {
    [currentClassName]: current,
    [todayClassName]: today != null && isSameDay(value, today),
  })

  return (
    <Component {...componentProps} className={componentClassName} size={size}>
      {format(value)}
    </Component>
  )
}

export default MonthDay
